var base = require('settings/profile/update-profile-photo');

Vue.component('spark-update-profile-photo', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/profile/update-profile-photo.js